module.exports = __webpack_public_path__ + "media/images/icons/flags/TG-b983a58bc62d111ac5ab4b606066e80c.svg";